import React from 'react';

type Status = 'cleared' | 'boarding' | 'delayed' | 'cancelled' | 'scheduled';

interface StatusBadgeProps {
    status: Status;
    className?: string;
}

/**
 * Nobel Aesthetic Component: Status Badge
 * Usage: Gate statuses, flight indicators
 * Variants: CLEARED (gold), BOARDING, DELAYED, CANCELLED, SCHEDULED
 */
export const StatusBadge: React.FC<StatusBadgeProps> = ({ status, className = '' }) => {
    const statusClasses = {
        cleared: 'status-cleared',
        boarding: 'status-boarding',
        delayed: 'status-delayed',
        cancelled: 'status-cancelled',
        scheduled: 'status-boarding', // Same as boarding
    };

    const statusText = {
        cleared: 'CLEARED',
        boarding: 'BOARDING',
        delayed: 'DELAYED',
        cancelled: 'CANCELLED',
        scheduled: 'SCHEDULED',
    };

    return (
        <span className={`${statusClasses[status]} px-3 py-1 rounded-full text-xs font-bold tracking-wider ${className}`}>
            {statusText[status]}
        </span>
    );
};
